import { BankingValueObjectsCardTypeEnum } from 'generated/resources/datatable.graphql'
import { BankingCardLimitPeriodEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { isSingleUse } from './isSingleUse'

export const cardLimitPeriodText = (card: {
  type: BankingValueObjectsCardTypeEnum
  cardLimit?: { period?: BankingCardLimitPeriodEnum | null | undefined }
}): string | undefined => {
  if (isSingleUse(card)) {
    return i18n.t('expenses_v2.cards.details.one_time')
  } else if (card.cardLimit?.period) {
    switch (card.cardLimit?.period) {
      case 'daily':
        return i18n.t('expenses_v2.cards.details.until_next_day')
      case 'monthly':
        return i18n.t('expenses_v2.cards.details.until_next_month')
      case 'weekly':
        return i18n.t('expenses_v2.cards.details.until_next_week')
      case 'yearly':
        return i18n.t('expenses_v2.cards.details.until_next_year')
      default:
        return card.cardLimit?.period satisfies never
    }
  }
}
